import React from 'react'
import Main from '../Components/LoginComponent/Main'

const Login = () => {
  return (
    <>
      <Main />
    </>
  )
}

export default Login
